import { buildOrderProductUniqueIdentifier } from '../../../../../../../utils/getOrderProductUniqueIdentifier';
import { useOrderEditSectionsContext } from '../../../../../edit/sections/OrderEditSections.context';
import { filterViolationsByItem } from '../../../../../edit/validate/conditions/businessPolicy/businessPolicyViolation.utils';
import { OrderProductKeyIds } from '../../../../orderProducts.types';

export const useOrderProductPolicyViolations = (orderProductKeyIds?: OrderProductKeyIds) => {
  const {
    productsBusinessPolicyViolationsByItem,
    productsBusinessPolicyViolations,
    openPolicyViolationsModal,
  } = useOrderEditSectionsContext();

  const productKey = orderProductKeyIds
    ? buildOrderProductUniqueIdentifier({
        productColorId: orderProductKeyIds.productColorId,
        availability: orderProductKeyIds.availability,
        deliveryWindowId: orderProductKeyIds.deliveryWindowId || null,
      })
    : undefined;

  const productBusinessPolicyViolations = productKey
    ? (productsBusinessPolicyViolationsByItem.get(productKey) ?? [])
    : [];

  const openProductPolicyViolations = productBusinessPolicyViolations.length
    ? () =>
        openPolicyViolationsModal(
          filterViolationsByItem(productsBusinessPolicyViolations, productBusinessPolicyViolations),
        )
    : undefined;

  return { productBusinessPolicyViolations, openProductPolicyViolations };
};
